<template>
  <div class="mt-2">
    <fcc-table
      striped
      hover
      responsive
      :items="equipes"
      :fields="fields"
      :optionsButton="options"
      :actions="actions"
      pagination
    />

    <fccModal
      idModal="modal-equipes"
      :titleModal="titleModal"
      centered
      escondeFooter
      @close="limparForm"
    >
      <b-form @submit.prevent="salvar" autocomplete="off"
        ><div class="row mb-4">
          <div class="col"><fcc-input v-model="form.descricao" required>Descrição</fcc-input></div>
        </div>

        <div class="row text-right">
          <div class="col"><fcc-button type="submit">Salvar</fcc-button></div>
        </div>
      </b-form>
    </fccModal>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import { acaoConstantes } from '../constants'
import axios from 'axios'

export default {
  data() {
    return {
      itemSelecionado: null,
      form: { descricao: '' },
      acaoModal: acaoConstantes.ADICIONAR,
      fields: [
        { key: 'idequipe', label: 'ID', sortable: true },
        { key: 'descricao', label: 'Descriçao', sortable: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editField',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        },
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      options: [
        {
          funcaoButton: 'adicionar',
          text: 'Adicionar',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['equipes']),
    titleModal() {
      return this.acaoModal === acaoConstantes.ADICIONAR ? 'Adicionar Equipe' : 'Editar Equipe'
    }
  },
  mounted() {
    this.atualizarItens()
  },
  methods: {
    limparForm() {
      this.form = { descricao: '' }
    },
    atualizarItens() {
      store
        .dispatch('acompanhamentoDeProjetos/fetchEquipes', this.dadosLoginSession.fccTokenHeaders)
        .then(() => this.$emit('carregado'))
        .catch(this.setErrorSystem)
    },
    adicionar() {
      this.acaoModal = acaoConstantes.ADICIONAR
      this.$root.$emit('bv::show::modal', 'modal-equipes')
    },
    editField(_, item) {
      this.itemSelecionado = item
      this.form.descricao = item.descricao
      this.acaoModal = acaoConstantes.EDITAR
      this.$root.$emit('bv::show::modal', 'modal-equipes')
    },
    deleteField(_, item) {
      this.callConfirm('Deseja excluir a equipe?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.equipeExcluir(item.idequipe)
            .then(() => {
              this.carregaTexto()
              this.atualizarItens()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    salvar() {
      this.callConfirm(
        this.acaoModal === acaoConstantes.ADICIONAR
          ? 'Deseja adicionar uma equipe?'
          : 'Deseja editar a euipe?',
        ''
      ).then((result) => {
        if (result.value) {
          const methodTipoSistema =
            this.acaoModal === acaoConstantes.ADICIONAR ? this.equipeAdicionar : this.equipeAlterar

          this.carregaTexto(this.codeMensagem('C01'))
          methodTipoSistema()
            .then(() => {
              this.carregaTexto()
              this.limparForm()
              this.atualizarItens()
              this.$root.$emit('bv::hide::modal', 'modal-equipes')
              this.acaoModal === acaoConstantes.ADICIONAR
                ? this.callToast(this.mensagensUpdate.adicionado)
                : this.callToast(this.mensagensUpdate.editado, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    equipeAdicionar() {
      const payload = {
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.post(
        store.state.baseUrlGestaoProjetos + 'Equipe/Adicionar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    equipeAlterar() {
      const payload = {
        idEquipe: this.itemSelecionado.idequipe,
        descricao: this.form.descricao,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.put(
        store.state.baseUrlGestaoProjetos + 'Equipe/Alterar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    equipeExcluir(idEquipe) {
      return axios.delete(
        store.state.baseUrlGestaoProjetos + 'Equipe/Excluir/' + idEquipe,
        this.dadosLoginSession.fccTokenHeaders
      )
    }
  }
}
</script>